var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_85133",
    "data-name": "Group 85133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170.993,
    height: 171,
    viewBox: "0 0 170.993 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24854",
    "data-name": "Rectangle 24854",
    width: 74.32,
    height: 74.077,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84670",
    "data-name": "Group 84670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M128.7,8.611l1,1.982,7.463,19.862a5.769,5.769,0,0,0,3.381,3.381l19.175,7.2a17.348,17.348,0,0,1,10.7,20.652l-.544,1.684-8.914,19.732a5.779,5.779,0,0,0,0,4.794l8.473,18.656a17.36,17.36,0,0,1-7.048,22.155l-1.982,1-19.861,7.463a5.794,5.794,0,0,0-3.369,3.381l-7.2,19.175a17.361,17.361,0,0,1-20.665,10.7l-1.684-.544-19.731-8.914a5.78,5.78,0,0,0-4.794,0l-18.644,8.473A17.36,17.36,0,0,1,42.3,162.4l-1-1.982-7.476-19.862a5.792,5.792,0,0,0-3.382-3.369l-19.175-7.2a17.361,17.361,0,0,1-10.7-20.665l.544-1.684L10.04,87.9a5.791,5.791,0,0,0,0-4.794L1.553,64.465A17.361,17.361,0,0,1,8.588,42.31l1.982-1,19.874-7.489a5.792,5.792,0,0,0,3.382-3.382l7.2-19.175A17.361,17.361,0,0,1,61.682.566l1.684.544L83.1,10.036a5.792,5.792,0,0,0,4.794,0l18.656-8.473A17.361,17.361,0,0,1,128.7,8.6Z",
    transform: "translate(0 0)",
    fill: "#ffded7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85113",
    "data-name": "Group 85113",
    transform: "translate(48.462 48.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85112",
    "data-name": "Group 85112",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241203",
    "data-name": "Path 241203",
    d: "M31.954,79.4V73.856l-3.608-.528a12.3,12.3,0,0,0-1.134-2.748l2.181-2.937-3.9-3.918-2.923,2.191a12.132,12.132,0,0,0-2.736-1.14l-.525-3.625H13.792l-.525,3.625a12.146,12.146,0,0,0-2.736,1.14L7.608,63.725l-3.9,3.918L5.888,70.58a12.3,12.3,0,0,0-1.134,2.748l-3.608.528V79.4l3.608.528a12.258,12.258,0,0,0,1.134,2.748L3.708,85.608l3.9,3.918,2.923-2.191a12.132,12.132,0,0,0,2.736,1.14l.525,3.624h5.516l.525-3.624a12.132,12.132,0,0,0,2.736-1.14l2.923,2.191,3.9-3.918-2.181-2.937a12.258,12.258,0,0,0,1.134-2.748Z",
    transform: "translate(-0.353 -18.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241204",
    "data-name": "Path 241204",
    d: "M50.128,65.507a3.529,3.529,0,0,0-2.807-2.744,3.589,3.589,0,0,0-3.233,1,1.178,1.178,0,0,1-2-.853V54.8H18.537V78H42.084v-8.49a1.177,1.177,0,0,1,2-.854,3.572,3.572,0,0,0,2.551,1.065,3.53,3.53,0,0,0,3.495-4.216",
    transform: "translate(-5.704 -16.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24852",
    "data-name": "Rectangle 24852",
    width: 2.855,
    height: 23.203,
    transform: "translate(12.833 37.938)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241205",
    "data-name": "Path 241205",
    d: "M36.27,81.729H34.8a.793.793,0,0,1,0-1.586H36.27a.793.793,0,1,1,0,1.586",
    transform: "translate(-10.463 -24.659)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241206",
    "data-name": "Path 241206",
    d: "M26.843,81.729H25.372a.793.793,0,0,1,0-1.586h1.471a.793.793,0,1,1,0,1.586",
    transform: "translate(-7.563 -24.659)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241207",
    "data-name": "Path 241207",
    d: "M42.085,21.283H18.538v23.2h8.229a1.158,1.158,0,0,1,.865,1.974,3.472,3.472,0,0,0-1.011,3.186,3.57,3.57,0,0,0,7.064-.677A3.469,3.469,0,0,0,32.6,46.455a1.157,1.157,0,0,1,.866-1.969h8.616Z",
    transform: "translate(-5.704 -6.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24853",
    "data-name": "Rectangle 24853",
    width: 2.855,
    height: 23.203,
    transform: "translate(12.833 14.734)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241208",
    "data-name": "Path 241208",
    d: "M52.127,47.808a.952.952,0,1,1-.952.952.952.952,0,0,1,.952-.952",
    transform: "translate(-15.746 -14.71)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241209",
    "data-name": "Path 241209",
    d: "M25.255,30.566a.793.793,0,0,1-.793-.793V28.3a.793.793,0,0,1,1.587,0v1.47a.793.793,0,0,1-.793.793",
    transform: "translate(-7.527 -8.465)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241210",
    "data-name": "Path 241210",
    d: "M25.255,39.986a.793.793,0,0,1-.793-.793v-1.47a.793.793,0,0,1,1.587,0v1.47a.793.793,0,0,1-.793.793",
    transform: "translate(-7.527 -11.363)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241211",
    "data-name": "Path 241211",
    d: "M92.248,1.146H68.7V9.485a1.008,1.008,0,0,1-1.77.6,3.59,3.59,0,0,0-3.238-.969,3.509,3.509,0,0,0,.714,6.955,3.569,3.569,0,0,0,2.517-1.031,1.009,1.009,0,0,1,1.776.593v8.715H92.248Z",
    transform: "translate(-18.721 -0.353)",
    fill: "#fda639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241212",
    "data-name": "Path 241212",
    d: "M68.961,12.717a3.266,3.266,0,0,0-.507-.156,3.291,3.291,0,0,0,.508-.159,3.1,3.1,0,0,0,1.959-2.93V1.146H68.7V9.485a1.008,1.008,0,0,1-1.769.6,3.591,3.591,0,0,0-3.238-.969,3.509,3.509,0,0,0,.713,6.955,3.57,3.57,0,0,0,2.517-1.031,1.009,1.009,0,0,1,1.776.593v8.715h2.221v-8.7a3.1,3.1,0,0,0-1.961-2.929",
    transform: "translate(-18.721 -0.353)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241213",
    "data-name": "Path 241213",
    d: "M100.81,18.977a1.15,1.15,0,0,0-1.15,1.15v6.258a1.15,1.15,0,0,1-1.15,1.151H93.555a1.15,1.15,0,0,0,0,2.3h7.255a1.15,1.15,0,0,0,1.15-1.15V20.127a1.15,1.15,0,0,0-1.15-1.15",
    transform: "translate(-28.432 -5.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241214",
    "data-name": "Path 241214",
    d: "M87.2,19.307a.793.793,0,0,1-.793-.793V17.379a5.2,5.2,0,0,1,2.319-4.409,2.992,2.992,0,0,0,1.338-2.7,2.868,2.868,0,0,0-5.733.191.793.793,0,1,1-1.586,0,4.454,4.454,0,0,1,8.9-.287A4.581,4.581,0,0,1,89.589,14.3a3.672,3.672,0,0,0-1.6,3.079v1.134A.793.793,0,0,1,87.2,19.307Z",
    transform: "translate(-25.46 -1.82)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241215",
    "data-name": "Path 241215",
    d: "M88.723,27.064a1.031,1.031,0,1,0,1.031,1.031,1.031,1.031,0,0,0-1.031-1.031",
    transform: "translate(-26.982 -8.327)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241216",
    "data-name": "Path 241216",
    d: "M89.139,91.837H75.109a.793.793,0,1,1,0-1.586H88.346V77.358a.793.793,0,0,1,1.587,0V91.044a.793.793,0,0,1-.793.793",
    transform: "translate(-22.866 -23.558)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241217",
    "data-name": "Path 241217",
    d: "M67.488,97.92h-1.43a.793.793,0,1,1,0-1.586h1.43a.793.793,0,1,1,0,1.586",
    transform: "translate(-20.081 -29.641)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241218",
    "data-name": "Path 241218",
    d: "M95.374,70.545a.793.793,0,0,1-.793-.793v-1.43a.793.793,0,0,1,1.587,0v1.43a.793.793,0,0,1-.793.793",
    transform: "translate(-29.102 -20.778)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241219",
    "data-name": "Path 241219",
    d: "M76.1,51.358H67.253a.975.975,0,0,1-.687-1.67,3.475,3.475,0,0,0,1.071-3.215,3.57,3.57,0,0,0-7.068.654A3.471,3.471,0,0,0,61.7,49.692a1.008,1.008,0,0,1-.393,1.666H52.55v8.334a1.165,1.165,0,0,0,1.972.628,3.59,3.59,0,0,1,3.234-1,3.509,3.509,0,0,1-.687,6.96,3.571,3.571,0,0,1-2.551-1.065,1.165,1.165,0,0,0-1.968.625v8.718H76.1Z",
    transform: "translate(-16.169 -13.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241220",
    "data-name": "Path 241220",
    d: "M57.069,71.945a5.785,5.785,0,0,0,4.486-2.113,5.716,5.716,0,0,0-3.4-9.252,5.881,5.881,0,0,0-3.389.375V54.8H52.55v8.333a1.164,1.164,0,0,0,1.972.628,3.59,3.59,0,0,1,3.234-1,3.509,3.509,0,0,1-.687,6.96,3.572,3.572,0,0,1-2.551-1.065,1.165,1.165,0,0,0-1.968.625V78h2.221V71.475A5.794,5.794,0,0,0,57.069,71.945Z",
    transform: "translate(-16.169 -16.861)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241221",
    "data-name": "Path 241221",
    d: "M79.139,71.618a.793.793,0,0,1-.793-.793v-1.47a.793.793,0,0,1,1.587,0v1.47a.793.793,0,0,1-.793.793",
    transform: "translate(-24.106 -21.096)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241222",
    "data-name": "Path 241222",
    d: "M79.139,81.038a.793.793,0,0,1-.793-.793v-1.47a.793.793,0,0,1,1.587,0v1.47a.793.793,0,0,1-.793.793",
    transform: "translate(-24.106 -23.994)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241223",
    "data-name": "Path 241223",
    d: "M37.981,2.431H30.206a.793.793,0,0,1,0-1.586h7.775a.793.793,0,1,1,0,1.586",
    transform: "translate(-9.05 -0.26)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241224",
    "data-name": "Path 241224",
    d: "M13.306,2.431h-1.43a.793.793,0,1,1,0-1.586h1.43a.793.793,0,1,1,0,1.586",
    transform: "translate(-3.41 -0.26)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241225",
    "data-name": "Path 241225",
    d: "M22.471,2.431H21.04a.793.793,0,1,1,0-1.586h1.43a.793.793,0,1,1,0,1.586",
    transform: "translate(-6.23 -0.26)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241226",
    "data-name": "Path 241226",
    d: "M28.816,11.6H21.041a.793.793,0,0,1,0-1.586h7.775a.793.793,0,1,1,0,1.586",
    transform: "translate(-6.23 -3.08)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241227",
    "data-name": "Path 241227",
    d: "M4.141,11.6H2.71a.793.793,0,1,1,0-1.586h1.43a.793.793,0,1,1,0,1.586",
    transform: "translate(-0.59 -3.08)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241228",
    "data-name": "Path 241228",
    d: "M13.306,11.6h-1.43a.793.793,0,1,1,0-1.586h1.43a.793.793,0,1,1,0,1.586",
    transform: "translate(-3.41 -3.08)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241229",
    "data-name": "Path 241229",
    d: "M18.955,93.684H13.439a.794.794,0,0,1-.785-.679L12.2,89.88a12.959,12.959,0,0,1-1.954-.813L7.73,90.953a.793.793,0,0,1-1.038-.075l-3.9-3.918a.794.794,0,0,1-.075-1.033L4.6,83.4a13.14,13.14,0,0,1-.812-1.968L.678,80.973A.794.794,0,0,1,0,80.188V74.647a.794.794,0,0,1,.678-.785l3.108-.454A13.1,13.1,0,0,1,4.6,71.44l-1.88-2.532a.793.793,0,0,1,.075-1.032l3.9-3.918a.793.793,0,0,1,1.038-.075l2.924,2.19a.793.793,0,1,1-.951,1.27L7.331,65.565,4.4,68.51,6.172,70.9a.794.794,0,0,1,.055.863,11.452,11.452,0,0,0-1.061,2.571.794.794,0,0,1-.65.573l-2.93.428V79.5l2.93.429a.792.792,0,0,1,.65.573,11.479,11.479,0,0,0,1.061,2.571.793.793,0,0,1-.055.862L4.4,86.324,7.331,89.27,9.7,87.492a.794.794,0,0,1,.867-.055A11.36,11.36,0,0,0,13.128,88.5a.793.793,0,0,1,.571.65l.426,2.946h4.143l.426-2.946a.793.793,0,0,1,.572-.65,11.374,11.374,0,0,0,2.557-1.065.794.794,0,0,1,.867.055l2.372,1.778,2.932-2.946-1.774-2.388a.793.793,0,0,1,1.274-.946l2.181,2.937a.793.793,0,0,1-.075,1.032l-3.9,3.918a.794.794,0,0,1-1.038.075l-2.517-1.886a12.959,12.959,0,0,1-1.954.813L19.739,93A.792.792,0,0,1,18.955,93.684Z",
    transform: "translate(0 -19.607)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241230",
    "data-name": "Path 241230",
    d: "M91.891,24.789H68.344A.793.793,0,0,1,67.551,24V15.281c.007-.215-.336-.156-.426-.029a4.358,4.358,0,0,1-7.347-3.9A4.4,4.4,0,0,1,67.134,9.17c.084.125.418.165.417-.025V.793A.793.793,0,0,1,68.344,0H91.891a.793.793,0,0,1,.793.793V24a.793.793,0,0,1-.793.793M69.137,23.2H91.1V1.586H69.137V9.132a1.809,1.809,0,0,1-3.131,1.154,2.8,2.8,0,0,0-4.672,1.369C60.722,14.245,64.2,16.024,66,14.133a1.809,1.809,0,0,1,3.138,1.16Z",
    transform: "translate(-18.364)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241231",
    "data-name": "Path 241231",
    d: "M63.131,43.34H54.286a.18.18,0,0,1-.15-.294,4.3,4.3,0,0,0-2.107-7.366A4.365,4.365,0,0,0,46.809,39.9a4.289,4.289,0,0,0,1.393,3.15c.078.074.029.233-.057.288H30.989a1.961,1.961,0,0,0-1.427,3.343c1.992,1.808.074,5.214-2.508,4.6a2.706,2.706,0,0,1-1.383-4.592,1.961,1.961,0,0,0-1.425-3.349H16.83V21.723H38.79V36.529a.793.793,0,0,0,1.587,0V20.93a.793.793,0,0,0-.793-.793H16.036a.793.793,0,0,0-.793.793V56.037a9,9,0,0,0-4.834,7.97c.121,9.46,12.632,12.381,16.973,4.123H63.131a.793.793,0,0,0,.793-.793v-23.2A.793.793,0,0,0,63.131,43.34ZM38.8,58.526a.825.825,0,0,0,0,.093v7.925H16.83V44.926h7.436c.384-.006.556.375.316.61a4.3,4.3,0,0,0,2.174,7.3,4.376,4.376,0,0,0,5.221-4.222,4.241,4.241,0,0,0-1.325-3.087.36.36,0,0,1,.317-.6H38.79v3.907h0v3.634a1.964,1.964,0,0,0,3.34,1.175A2.8,2.8,0,0,1,46.819,55c.616,2.607-2.9,4.381-4.693,2.451A1.971,1.971,0,0,0,38.8,58.526Zm23.542,8.018H40.377V58.681a.374.374,0,0,1,.609-.131,4.361,4.361,0,0,0,7.389-3.861c-.556-3.321-5.117-4.605-7.383-2.152a.373.373,0,0,1-.615-.132v-7.48h7.968a1.791,1.791,0,0,0,.93-3.043,2.693,2.693,0,0,1,.107-4.061,2.792,2.792,0,0,1,4.508,1.569,2.662,2.662,0,0,1-.818,2.48A1.778,1.778,0,0,0,54.3,44.926h8.04V66.544Z",
    transform: "translate(-3.203 -6.196)",
    fill: "#8e8e8e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/Problem.a3c077496f0efff8530e9d77185054b6.svg";
export { ForwardRef as ReactComponent };